import _ from 'lodash';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import duration from 'dayjs/plugin/duration';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Form, message, Collapse, Popconfirm, Select, DatePicker, Tooltip, Input, Modal, Button } from 'antd';
import {
  // getDeviceList,
  // getOrganisationsList,
  // getSitesList,
  getTaskList,
  getTaskById1,
  filterTaskByReference,
  submitTask
} from '../../../Utils/FormCalls';
import { StyledBox } from '../../../CSS/style';

const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;

const WorkOrderJobPlanes = (props) => {
  const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [fileData, setFileData] = useState(props.fileData || {});
  const [TaskList, setTaskList] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [viewEquipmentModal, setViewEquipmentModal] = useState(false);
  const workOrderJobPlanRef = useRef(null);
  const TaskRef = useRef(null);
  dayjs.extend(duration);

  useEffect(() => {
    const fetchData = async () => {

      try {
        let TaskListResponse = await getTaskList('Active');
        TaskListResponse = filterTaskByReference(TaskListResponse, recordData);
        setTaskList(TaskListResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
    if (workOrderJobPlanRef.current) {
      workOrderJobPlanRef.current.setFieldsValue(props.formObject);
    }
    generateEstimate(props.formObject);
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
    }
    if (props.formObject !== formObject) {
      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
      setFormObject(props.formObject);
      setRecordData(props.formObject?.TaskData || []);
      setFileData(props.fileData || null);
    }
  }, [props]);


  const onReset = () => {
    if (workOrderJobPlanRef.current) {
      workOrderJobPlanRef.current.resetFields();
    }
  };

  // const handleSelect = (value, mainIndex, subindex, keyName, selectedObject) => {
  //   const updatedFormObject = { ...formObject };
  //   const TaskData = updatedFormObject.TaskData.map((item, index) => {
  //     if (index === mainIndex) {
  //       item[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
  //     }
  //     return item;
  //   });
  //   updatedFormObject.TaskData = TaskData;
  //   if (workOrderJobPlanRef.current) {
  //     workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
  //   }
  // };

  const generateEstimate = (formObject) => {
    if (formObject && formObject.TaskData) {
      const TaskData1 = formObject.TaskData || [];
      let taskData = [];
      let totalDurationHr = 0;
      let total = 0;

      if (TaskData1 && Array.isArray(TaskData1)) {
        taskData = TaskData1.map((item) => {
          let EstimatedDuration = null;
          let d = 0;
          if (item.StartTime && item.EndTime) {
            const start = item.StartTime;
            const end = item.EndTime;
            const ms = dayjs(end, 'YYYY-MM-DD HH:mm').diff(dayjs(start, 'YYYY-MM-DD HH:mm'));
            d = dayjs.duration(ms);
            EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm');
            totalDurationHr += d.asHours() + totalDurationHr;
            total = ms + total;
          }

          return {
            ...item,
            EstimatedDuration: EstimatedDuration ? EstimatedDuration : '00:00'
          };
        });
      }
      const updatedFormObject = {
        ...formObject,
        TotalDowntime:
          Math.floor(dayjs.duration(total).asHours()) + dayjs.utc(total).format(':mm'),
        JobPlan: {
          ...(formObject.JobPlan || {}),
          TaskData:
            taskData && Array.isArray(taskData) && taskData.length > 0 ? taskData : TaskData1
        }
      };

      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
      }
      props.handleTotalDownTime(updatedFormObject);
    }
  };

  const datepickerchangeTask = (date, dateString, key) => {
    const formObject = TaskRef.current.getFieldsValue();
    let EstimatedDuration = null;
    let d = 0;

    if (key === 'EndTime' && TaskRef.current.getFieldValue('StartTime')) {
      const startTime = TaskRef.current.getFieldValue('StartTime');
      const endTime = date;
      const ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
      d = dayjs.duration(ms);
      EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm');
    } else if (key === 'StartTime' && TaskRef.current.getFieldValue('EndTime')) {
      const endTime = TaskRef.current.getFieldValue('EndTime');
      const startTime = date;
      const ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
      d = dayjs.duration(ms);
      EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm');
    }

    formObject['EstimatedDuration'] = EstimatedDuration;
    setFormObject(formObject);
    TaskRef.current.setFieldsValue(formObject);
  };

  const getDisabledHoursTask = (e, key) => {
    let hours = [];
    let minutes = [];
    let StartDateTime = '';
    let EndDateTime = '';
    let StartDate = '';
    let EndDate = '';

    if (key === 'StartTime') {
      StartDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
      EndDateTime = dayjs.utc(TaskRef.current.getFieldValue('EndTime'), 'YYYY-MM-DD HH:mm').local();
      StartDate = dayjs(e).format('YYYY-MM-DD');
      EndDate = dayjs.utc(TaskRef.current.getFieldValue('EndTime')).local().format('YYYY-MM-DD');
    } else if (key === 'EndTime') {
      StartDateTime = dayjs.utc(TaskRef.current.getFieldValue('StartTime'), 'YYYY-MM-DD HH:mm').local();
      EndDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
      StartDate = dayjs.utc(TaskRef.current.getFieldValue('StartTime')).local().format('YYYY-MM-DD');
      EndDate = dayjs(e).format('YYYY-MM-DD');
    }

    if (key === 'StartTime' && dayjs(StartDate).isSame(dayjs(EndDate))) {
      for (let i = 0; i <= 24; i++) {
        if (i > dayjs(EndDateTime).hour()) {
          hours.push(i);
        }
      }
      if (dayjs(StartDate).isSame(dayjs(EndDate))) {
        for (let i = 0; i <= 60; i++) {
          if (i > dayjs(EndDateTime).minute() - 1) {
            minutes.push(i);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    } else if (key === 'EndTime' && dayjs(StartDate).isSame(dayjs(EndDate))) {
      for (let i = 0; i < dayjs(StartDateTime).hour(); i++) {
        if (i < 25) {
          hours.push(i);
        }
      }
      if (dayjs(StartDateTime).hour() === dayjs(EndDateTime).hour()) {
        for (let i = 0; i < dayjs(StartDateTime).minute() + 1; i++) {
          if (i < 61) {
            minutes.push(i);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    }
  };

  const getDisabledHours = (e, index, key) => {
    let hours = [];
    let minutes = [];
    let StartDateTime = '';
    let EndDateTime = '';
    let StartDate = '';
    let EndDate = '';

    const taskData = workOrderJobPlanRef.current?.getFieldValue()?.TaskData;

    if (key === 'StartTime') {
      StartDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
      EndDateTime = dayjs
        .utc(taskData?.[index]?.EndTime, 'YYYY-MM-DD HH:mm')
        .local();

      StartDate = dayjs(e).format('YYYY-MM-DD');
      EndDate = dayjs
        .utc(taskData?.[index]?.EndTime)
        .local()
        .format('YYYY-MM-DD');
    } else if (key === 'EndTime') {
      StartDateTime = dayjs
        .utc(taskData?.[index]?.StartTime, 'YYYY-MM-DD HH:mm')
        .local();
      EndDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');

      StartDate = dayjs
        .utc(taskData?.[index]?.StartTime)
        .local()
        .format('YYYY-MM-DD');
      EndDate = dayjs(e).format('YYYY-MM-DD');
    }

    if (
      key === 'StartTime' &&
      dayjs(StartDate).isSame(dayjs(EndDate) || dayjs(StartDateTime).hour() === dayjs(EndDateTime).hour())
    ) {
      for (let i = 0; i <= 24; i++) {
        if (i > dayjs(EndDateTime).hour()) {
          hours.push(i);
        }
      }
      if (dayjs(StartDate).isSame(dayjs(EndDate))) {
        for (let i = 0; i <= 60; i++) {
          if (i > dayjs(EndDateTime).minute() - 1) {
            minutes.push(i);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    } else if (
      key === 'EndTime' &&
      dayjs(StartDate).isSame(dayjs(EndDate) || dayjs(StartDateTime).hour() === dayjs(EndDateTime).hour())
    ) {
      for (let i = 0; i < dayjs(StartDateTime).hour(); i++) {
        if (i < 25) {
          hours.push(i);
        }
      }

      if (dayjs(StartDateTime).hour() === dayjs(EndDateTime).hour()) {
        for (let i = 0; i < dayjs(StartDateTime).minute() + 1; i++) {
          if (i < 61) {
            minutes.push(i);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    }
  };

  // const taskFileupload = async (values, key, fileDataObject, index) => {
  //   const updatedFormObject = { ...formObject };
  //   if (updatedFormObject.TaskData[index][key]) {
  //     updatedFormObject.TaskData[index][key].push(...values);
  //   } else {
  //     updatedFormObject.TaskData[index][key] = values;
  //   }
  //   updatedFormObject.TaskData[index][key] = updatedFormObject.TaskData[index][key].reduce((acc, current) => {
  //     const x = acc.find(item => item.Name === current.Name);
  //     if (!x) {
  //       return acc.concat([current]);
  //     } else {
  //       return acc;
  //     }
  //   }, []);
  //   props.fileAppend(fileDataObject);
  //   setFormObject(updatedFormObject);
  // };

  const datepickerchange = (date, dateString, index, key) => {
    const updatedFormObject = workOrderJobPlanRef.current && workOrderJobPlanRef.current.getFieldsValue();
    let EstimatedDuration = null;

    if (key === 'EndTime' && updatedFormObject && updatedFormObject.TaskData && updatedFormObject.TaskData[index]['StartTime']) {
      const startTime = updatedFormObject && updatedFormObject.TaskData && updatedFormObject.TaskData[index]['StartTime'];
      const endTime = date;
      const ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
      EstimatedDuration = dayjs.duration(ms);
    } else if (key === 'StartTime' && updatedFormObject && updatedFormObject.TaskData && updatedFormObject.TaskData[index]['EndTime']) {
      const endTime = updatedFormObject && updatedFormObject.TaskData && updatedFormObject.TaskData[index]['EndTime'];
      const startTime = date;
      const ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
      EstimatedDuration = dayjs.duration(ms);
    }

    updatedFormObject && updatedFormObject.TaskData ? updatedFormObject.TaskData[index]['EstimatedDuration'] = EstimatedDuration : null;
    setFormObject(updatedFormObject);
    generateEstimate(updatedFormObject);
  };

  const onTaskModalOk = () => {
    TaskRef.current.validateFields()
      .then(async (values) => {
        values = {
          ...values,
          siteId: props.siteId,
          Equipment: props.Equipment?.Device || ''
        };
        const TaskResponse = await submitTask(values);
        if (TaskResponse) {
          message.success(TaskResponse.message);
          const TaskListResponse = await getTaskList();
          const updatedFormObject = workOrderJobPlanRef.current.getFieldsValue();
          setViewEquipmentModal(false);
          setTaskList(TaskListResponse);
          setFormObject(updatedFormObject);
          if (TaskRef.current) {
            TaskRef.current.resetFields();
          }
        }
      })
      .catch(() => { });
  };

  const onTaskModalCancel = () => {
    TaskRef.current.resetFields();
    setViewEquipmentModal(false);
  };

  const TaskOnChange = async (value, val) => {
    let TaskData = {};
    let TaskArray = val === 'key' ? value : await getTaskById1(value, 'withoutid');
    if (TaskArray && !Array.isArray(TaskArray)) {
      TaskData = TaskArray;
    } else if (TaskArray && Array.isArray(TaskArray) && TaskArray[0]) {
      TaskData = TaskArray[0];
    }

    const updatedFormObject = workOrderJobPlanRef.current.getFieldsValue();
    if (TaskData) {
      _.cloneDeepWith(TaskData, (value) => {
        return value !== undefined || value !== null || value.StartTime || value.EndTime
          ? {
            ...value,
            ...(value.StartTime ? (value.StartTime = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss').local()) : null),
            ...(value.EndTime ? (value.EndTime = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss').local()) : null)
          }
          : _.noop();
      });
    }

    if (updatedFormObject && updatedFormObject.TaskData) {
      const TaskData1 = updatedFormObject.TaskData || [];
      TaskData1.push(TaskData);
      let totalDuration = '00:00';
      let result = dayjs.duration();

      const taskData = TaskData1.map((item) => {
        let EstimatedDuration = null;
        if (item.StartTime && item.EndTime) {
          const start = item.StartTime;
          const end = item.EndTime;
          const ms = dayjs(end, 'YYYY-MM-DD HH:mm').diff(dayjs(start, 'YYYY-MM-DD HH:mm'));
          const d = dayjs.duration(ms);
          EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm');
          result = dayjs.duration(EstimatedDuration);
          result.add(dayjs.duration(totalDuration));
          totalDuration = `${Math.floor(result.asHours())}:${Math.floor(result.minutes())}`;
        }
        return {
          ...item,
          EstimatedDuration: EstimatedDuration || '00:00'
        };
      });

      const finalFormObject = {
        TotalDowntime: totalDuration,
        JobPlan: {
          ...(updatedFormObject.JobPlan || {}),
          TaskData: taskData.length > 0 ? taskData : []
        }
      };

      setSelectedTask(value);
      props.handleTotalDownTime(finalFormObject);
      workOrderJobPlanRef.current.setFieldsValue(finalFormObject);
      props.onFinish(workOrderJobPlanRef.current.getFieldsValue(), 'JobPlan', fileData);
    }
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  const styledCollapse = (index, translationCache) => (
    <span>
      <span style={{ fontWeight: 'bold' }}>{translation(translationCache, 'Task Name')}</span>:
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {workOrderJobPlanRef.current?.getFieldsValue()?.TaskData?.[index]?.TaskName || ''}
      </span>
      <span style={{ fontWeight: 'bold' }}>
        {translation(translationCache, 'Task Description')}
      </span> :
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {workOrderJobPlanRef.current?.getFieldsValue()?.TaskData?.[index]?.TaskDescription || ''}
      </span>
    </span>
  );

  return (
    <div style={{ marginTop: '5px', marginBottom: '30px', color: 'black', fontWeight: 'bold' }}>
      <Form
        ref={workOrderJobPlanRef}
        name={'jobplan'}
        onFinish={(values) => props.onFinish(values, 'JobPlan', fileData)}
        initialValues={formObject}
        layout="vertical"
        validateMessages={validateMessages}
      >
        <Form.List
          initialValue={formObject && formObject.TaskData || []}
          name="TaskData"
        >
          {(fields, { remove }) => (
            <>
              <StyledBox>
                <Form.Item
                  label={translation(props.translationCache, constant.addTask)}
                  name="TaskName"
                >
                  <Select
                    style={{ width: "100%" }}
                    showSearch={true}
                    placeholder={translation(props.translationCache, constant.selectTask)}
                    defaultValue={selectedTask}
                    onChange={(value) => TaskOnChange(value)}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {TaskList.map((task, index) => (
                      <Option
                        key={index}
                        value={task.Id}
                        disabled={workOrderJobPlanRef.current?.getFieldsValue()?.TaskData?.filter(
                          (item) => item?.TaskName === task.TaskName
                        ).length > 0}
                      >
                        {task.TaskName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item>
                  <Button
                  type="primary"
                  disabled={props.addTask ? props.addTask : false}
                  onClick={() => setViewEquipmentModal(true)}
                >
                  {translation(props.translationCache, constant.add)}
                </Button>
                </Form.Item>
              </StyledBox>
            
              {fields.length > 0 && (
                <Collapse accordion defaultActiveKey={[]}>
                  {fields.map(({ key, name }, index) => (
                    <Panel
                      key={key}
                      header={styledCollapse(index, props.translationCache)}
                      extra={
                        <Popconfirm
                          title={translation(props.translationCache, 'Are you sure that you want to delete the task？')}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(name)}
                          okText={translation(props.translationCache, constant.yes)}
                          cancelText={translation(props.translationCache, constant.no)}
                        >
                          <Tooltip title={translation(props.translationCache, 'Delete')} placement="bottom">
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(props.translationCache, constant.TaskName)}
                          
                          name={[name, 'TaskName']}
                          rules={[{ required: true, message: 'TaskName is required' }]}
                        >
                          <InputComponent
                            placeholder={translation(props.translationCache, 'Enter TaskName')}
                            style={{ width: '100%' }}
                            disabled={true}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(props.translationCache, constant.description)}
                          name={[name, 'TaskDescription']}
                          
                        >
                          <TextArea
                            disabled={true}
                            rows={3}
                            style={{ width: '100%' }}
                            placeholder={translation(props.translationCache, 'Enter Description')}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(props.translationCache, constant.startTime)}
                          
                          name={[name, 'StartTime']}
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            inputReadOnly={true}
                            placeholder={translation(props.translationCache, constant.startDate)}
                            onChange={(date, dateString) => {
                              datepickerchange(date, dateString, key, 'StartTime');
                            }}
                            showTime={true}
                            showNow={false}
                            disabledDate={(d) =>
                              !d ||
                              d.isAfter(
                                workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[key][
                                  'EndTime'
                                  ]
                                  ? dayjs(
                                    workOrderJobPlanRef.current.getFieldValue().TaskData[
                                    key
                                    ]['EndTime']
                                  )
                                    // .add(1, 'day')
                                    .format('YYYY-MM-DD HH:mm:ss')
                                  : ''
                              ) ||
                              d.isBefore(
                                workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[key][
                                  'StartTime'
                                  ]
                                  ? dayjs(
                                    workOrderJobPlanRef.current.getFieldValue().TaskData[
                                    key
                                    ]['StartTime']
                                  ).format('YYYY-MM-DD')
                                  : ''
                              ) ||
                              d.isAfter(dayjs().format('YYYY-MM-DD 23:59:59'))
                            }
                            disabledTime={(e) =>
                              getDisabledHours(
                                dayjs(e, 'YYYY-MM-DD HH:mm:ss'),
                                key,
                                'StartTime'
                              )
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(props.translationCache, constant.endTime)}
                          
                          name={[name, 'EndTime']}
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            inputReadOnly={true}
                            disabled={
                              workOrderJobPlanRef.current &&
                                workOrderJobPlanRef.current.getFieldValue() &&
                                workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                workOrderJobPlanRef.current.getFieldValue().TaskData[key] &&
                                workOrderJobPlanRef.current.getFieldValue().TaskData[key][
                                'StartTime'
                                ]
                                ? false
                                : true
                            }
                            placeholder={translation(props.translationCache, constant.selectEndDate)}
                            onChange={(date, dateString) => {
                              datepickerchange(date, dateString, key, 'EndTime');
                            }}
                            showTime={{
                              hideDisabledOptions: true,
                              defaultValue: dayjs('23:59:59', 'HH:mm:ss')
                            }}
                            disabledDate={(d) =>
                              !d ||
                              d.isBefore(
                                workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[key][
                                  'StartTime'
                                  ]
                                  ? dayjs(
                                    workOrderJobPlanRef.current.getFieldValue().TaskData[
                                    key
                                    ]['StartTime']
                                  ).format('YYYY-MM-DD')
                                  : ''
                              )
                            }
                            disabledTime={(e) =>
                              getDisabledHours(
                                dayjs(e, 'YYYY-MM-DD HH:mm:ss'),
                                key,
                                'EndTime'
                              )
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(props.translationCache, constant.duration)}
                          name={[name, 'EstimatedDuration']}
                          
                        >
                          <InputComponent
                            disabled={true}
                            style={{ width: '100%' }}
                            placeholder="Autopopulte based on Start and End time!"
                          />
                        </Form.Item>
                     
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              )}
              <Modal
                open={viewEquipmentModal}
                width={800}
                closable
                title={translation(props.translationCache, constant.addTasks)}
                footer={null}
                onOk={onTaskModalOk}
                onCancel={onTaskModalCancel}
              >
                <Form
                  layout="vertical"
                  ref={TaskRef}
                  name="user_form"
                  onFinish={onTaskModalOk}
                >
                  <div style={{ marginLeft: '85%' }}>
                    <Form.Item>
                      <Button htmlType="submit">
                        {translation(props.translationCache, constant.submit)}
                      </Button>
                    </Form.Item>
                  </div>
                  <Form.Item
                    label={translation(props.translationCache, constant.TaskName)}
                    
                    name={'TaskName'}
                    rules={[{ required: true, message: translation(props.translationCache, 'TaskName is required') }]}
                  >
                    <InputComponent
                      placeholder={translation(props.translationCache, 'Enter TaskName')}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={translation(props.translationCache, constant.description)}
                    rules={[{ required: true, message: translation(props.translationCache, 'TaskDescription is required') }]}
                    name={'TaskDescription'}
                    
                  >
                    <TextArea
                      rows={3}
                      style={{ width: '100%' }}
                      placeholder={translation(props.translationCache, 'Enter Description')}
                    />
                  </Form.Item>
                  <Form.Item
                    label={translation(props.translationCache, constant.startTime)}
                    
                    name={'StartTime'}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD HH:mm:ss"
                      inputReadOnly={true}
                      placeholder={translation(props.translationCache, constant.startDate)}
                      onChange={(date, dateString) => {
                        datepickerchangeTask(date, dateString, 'StartTime');
                      }}
                      showTime={true}
                      disabledDate={(d) =>
                        !d ||
                        d.isAfter(
                          TaskRef.current.getFieldValue() &&
                            TaskRef.current.getFieldValue().TaskData &&
                            TaskRef.current.getFieldValue('EndTime')
                            ? dayjs(
                              TaskRef.current
                                .getFieldValue('EndTime')
                                .add(1, 'day')
                                .format('YYYY-MM-DD')
                            )
                            : ''
                        ) ||
                        d.isBefore(
                          TaskRef.current.getFieldValue() &&
                            TaskRef.current.getFieldValue('StartTime')
                            ? dayjs(
                              TaskRef.current
                                .getFieldValue('StartTime')
                                .format('YYYY-MM-DD')
                            )
                            : ''
                        ) ||
                        d.isAfter(dayjs().add(1, 'day').format('YYYY-MM-DD'))
                      }
                      disabledTime={(e) =>
                        getDisabledHoursTask(dayjs(e, 'YYYY-MM-DD HH:mm:ss'), 'StartTime')
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label={translation(props.translationCache, constant.endTime)}
                    style={{ width: '100%', flex: '50%', color: 'white' }}
                    name={'EndTime'}
                    rules={[{ required: false, message: 'Autopopulte based on Start and End time!' }]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD HH:mm:ss"
                      inputReadOnly={true}
                      placeholder={translation(props.translationCache, constant.selectDate)}
                      onChange={(date, dateString) => {
                        datepickerchangeTask(date, dateString, 'EndTime');
                      }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: dayjs('23:59:59', 'HH:mm:ss')
                      }}
                      disabledDate={(d) =>
                        !d ||
                        d.isBefore(
                          TaskRef.current.getFieldValue() &&
                            TaskRef.current.getFieldValue('StartTime')
                            ? dayjs(TaskRef.current.getFieldValue('StartTime')).format(
                              'YYYY-MM-DD'
                            )
                            : ''
                        )
                      }
                      disabledTime={(e) =>
                        getDisabledHoursTask(dayjs(e, 'YYYY-MM-DD HH:mm:ss'), 'EndTime')
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label={translation(props.translationCache, constant.duration)}
                    name={'EstimatedDuration'}
                    rules={[{ required: false, message: 'Autopopulte based on Start and End time!' }]}
                    
                  >
                    <InputComponent
                      disabled={true}
                      style={{ width: '100%' }}
                      placeholder={translation(props.translationCache, 'Autopopulte based on Start and End time!')}
                    />
                  </Form.Item>
                </Form>
              </Modal>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderJobPlanes);